import { render, staticRenderFns } from "./RegistryReports.vue?vue&type=template&id=6b16c40f&"
import script from "./RegistryReports.vue?vue&type=script&lang=js&"
export * from "./RegistryReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports